import styled from 'styled-components';
export var IconBlock = styled.span.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-1l5bdzy-0"
})([""]);